// extracted by mini-css-extract-plugin
export default {"description":"ConfirmOTPCode_description__OiKg0","description__phone":"ConfirmOTPCode_description__phone__J7yxD"};